export function setStyleProperty(propertyName: string, value: string | null, priority?: string) {
  document.documentElement.style.setProperty(propertyName, value, priority);
}

export function getStyleProperty(propertyName: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(propertyName);
}
